<template>
  <div id="manning-vessel-list" class="h-full">
    <!-- 右上アクションボタン領域 -->

    <div class="flex w-full justify-between items-center mx-2 py-2 break-keep">
      <div class="flex justify-start items-center">
        <div class="mt-3 mb-3 mr-6 aisea-text-18-600-dark-gray">
          乗船期間一覧
        </div>
        <vs-radio
          v-model="isAllPeriod"
          vs-name="isAllPeriod"
          :vs-value="false"
          :color="AISEA_COLOR.BLUE"
        >
          <div class="flex items-center">
            <span class="font-normal mr-2">基準労働期間で絞り込み</span>
          </div>
        </vs-radio>
        <vs-tooltip
          text="基準労働時間"
          position="top"
          delay="2s"
          style="position: relative"
        >
          <dropdown-select
            class="filter-input"
            :selectOptions="workPeriodOptions"
            :selectedValue.sync="selectedWorkPeriod"
            placeholder="基準労働期間を選択してください"
            :border="true"
          ></dropdown-select>
        </vs-tooltip>
        <vs-radio
          class="ml-6"
          v-model="isAllPeriod"
          vs-name="isAllPeriod"
          :vs-value="true"
          :color="AISEA_COLOR.BLUE"
        >
          <span class="font-normal">全ての期間</span>
        </vs-radio>
      </div>
      <div class="flex flex-wrap justify-end items-center">
        <vs-button
          icon="add"
          :color="AISEA_COLOR.BLUE"
          type="border"
          style="margin: 0 0.6rem; height: 2.7rem"
          @click="
            () => {
              this.setActionDialogAdd();
              this.showActionDialog = true;
            }
          "
          ><span class="aisea-text-14-400-blue">新規登録</span></vs-button
        >
      </div>
    </div>

    <vs-divider :color="AISEA_COLOR.LIGHT_GRAY" class="my-0" />

    <!-- AgGrid Table -->
    <div style="height: calc(100% - 120px)">
      <ag-grid-vue
        ref="agGridTableManningVesselList"
        :components="components"
        :gridOptions="gridOptions"
        @sortChanged="onSort"
        class="ag-theme-material w-full ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="tableData"
        domLayout="autoHeight"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :suppressDragLeaveHidesColumns="true"
        :suppressCellFocus="true"
        :suppressRowClickSelection="true"
        :suppressNoRowsOverlay="false"
        @grid-ready="onGridReady"
        @grid-size-changed="onGridSizeChanged"
      />
    </div>

    <!-- 新規ボタン領域 -->
    <div
      id="manning-vessel-list-add-button"
      style="display: none; position: absolute;"
    >
      <div class="flex w-full justify-center">
        <vs-button
          icon="add"
          :color="AISEA_COLOR.BLUE"
          type="border"
          style="margin: 0 0.6rem; height: 2.7rem;"
          @click="showCrewSidebarForCreate(false)"
          ><span class="aisea-text-14-400-blue">新規登録</span></vs-button
        >
      </div>
    </div>

    <!-- ページネーション領域 -->
    <div class="flex justify-end items-center" style="margin: 0.6rem 0;">
      <div style="margin-right: 2rem;">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2 aisea-text-12-400-black"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
              -
              {{
                totalVessel - currentPage * paginationPageSize > 0
                  ? currentPage * paginationPageSize
                  : totalVessel
              }}
              / {{ totalVessel }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="onChangePageSize(25)">
              <span class="aisea-text-12-400-black">25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(50)">
              <span class="aisea-text-12-400-black">50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(75)">
              <span class="aisea-text-12-400-black">75</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(100)">
              <span class="aisea-text-12-400-black">100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div>
        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="currentPage"
          :color="AISEA_COLOR.BLUE"
        />
      </div>
    </div>

    <vs-prompt
      :title="actionDialogTitle"
      :color="AISEA_COLOR.BLUE"
      buttons-hidden
      :active.sync="showActionDialog"
      class="corp-manning-vessel-list-add-dialog"
    >
      <div class="required-info-edit-form-container">
        <div class="mb-5">
          必要事項を入力してください。「<label></label>」は入力必須項目です。
        </div>

        <div class="flex items-center justify-between mb-5">
          <div>
            <label>期間</label>
            <div class="flex items-center fixed-width-item justify-between">
              <date-picker
                :value.sync="dialogStartDate"
                dateFormat="Y/m/d"
                placeholder="2022/01/01"
              ></date-picker>
              <div class="mx-3 h-fit">〜</div>
              <date-picker
                :value.sync="dialogEndDate"
                dateFormat="Y/m/d"
                placeholder="2022/02/01"
              ></date-picker>
            </div>
          </div>
        </div>

        <div class="form-item mb-5">
          <label class="form-item-title">
            {{ actionDialogVesselFormLabel }}
          </label>
          <div class="input-area fixed-width-item">
            <dropdown-select
              class="filter-input"
              :selectOptions="filteredVesselOptions"
              :selectedValue.sync="dialogSelectedVessel"
              placeholder="船名を選択してください"
              :border="true"
            ></dropdown-select>
          </div>
        </div>

        <label class="form-item-title mb-1">
          役職
        </label>
        <div class="form-scroll-area">
          <div class="option-form-area">
            <role-form-item
              class="option-form-item mb-2"
              v-for="(form, index) in mandatoryRoleFormItems"
              :roleOptions="roleOptions"
              :key="index"
              :deleteButton="false"
              :isDateSelectDisabled="true"
              :value.sync="mandatoryRoleFormItems[index]"
              :isApproverCheckboxDisabled="
                getApproverFixed(form ? form.role : null)
              "
              ref="mandatoryOption"
            >
            </role-form-item>

            <role-form-item
              class="option-form-item  mb-2"
              v-for="(form, index) in optionalRoleFormItems"
              :roleOptions="roleOptions"
              :key="index + 1 + '-' + optionalRoleFormItems.length"
              :deleteButton="true"
              :value.sync="optionalRoleFormItems[index]"
              :onClickDelete="() => deleteOptionalRoleFormItem(index)"
              :isApproverCheckboxDisabled="
                getApproverFixed(form ? form.role : null)
              "
            >
            </role-form-item>
            <add-button
              class="add-option-button my-5"
              :click="addRoleForm"
              title="役職を追加"
              icon="PlusIcon"
            ></add-button>
          </div>
        </div>
      </div>
      <span class="validation-label">{{ getDialogValidationMessage }}</span>
      <div class="flex w-full justify-end items-center">
        <div class="m-3 mb-0">
          <vs-button
            type="border"
            style="width: 6rem; padding: 0.4rem"
            @click="onActionDialogCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div class="m-3 mb-0">
          <vs-button
            :color="AISEA_COLOR.BLUE"
            style="width: 6rem; padding: 0.4rem"
            @click="
              () => {
                if (actionMode == 'edit') {
                  onEdit();
                } else if (actionMode == 'delete') {
                  onDelete();
                } else if (actionMode == 'add') {
                  onAdd();
                } else if (actionMode == 'transfer') {
                  onTransfer();
                }
              }
            "
            :disabled="getDialogValidationMessage != null"
            >保存</vs-button
          >
        </div>
      </div>
    </vs-prompt>

    <vs-prompt
      title="船舶情報削除"
      type="confirm"
      :color="AISEA_COLOR.BLUE"
      accept-text="実行"
      cancel-text="キャンセル"
      :active.sync="showDeleteDialog"
      @accept="onDelete"
      @cancel="onDeleteCancel"
      class="corp-manning-vessel-list-delete-dialog"
    >
      <div>
        {{ dialogTargetPeriodLabel }}の船舶情報を削除しますか？<br />
        削除したデータは戻せません。
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import Vue from "vue";
import CellRendererVesselName from "./cell-renderer/CellRendererVesselName.vue";
import CellRendererRowActionButtons from "./cell-renderer/CellRendererRowActionButtons.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseManningCrewApi = AiseaApiFactory.get("enterpriseManningCrew");
const enterpriseCrewManningVesselApi = AiseaApiFactory.get(
  "enterpriseCrewManningVessel"
);
const enterpriseCrewRoleApi = AiseaApiFactory.get("enterpriseCrewRole");
const enterpriseCrewLaborApi = AiseaApiFactory.get("enterpriseCrewLabor");

import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DropdownSelect from "../components/DropdownSelect.vue";
import AddButton from "../components/AddButton.vue";
import DatePicker from "../components/DatePicker.vue";
import RoleFormItem from "../components/RoleFormItem.vue";
import * as DateUtil from "@/utils/DateUtil.js";
import moment from "moment";

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererVesselName,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererRowActionButtons,
    DropdownSelect,
    AddButton,
    DatePicker,
    RoleFormItem,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  data() {
    return {
      enterpriseCrewId: this.$route.params.id,

      mandatoryRoleFormItems: [null],
      optionalRoleFormItems: [],

      tableData: [],

      showActionDialog: false,
      showDeleteDialog: false,

      actionMode: null, // edit or add or transfer
      actionDialogTitle: "",
      actionDialogVesselFormLabel: "",

      updatedManningVesselPeriodIds: [],

      pageable: {
        page: 0,
        total_elements: 0,
        total_pages: 1,
      },

      currentPage: 1,
      gridApi: null,
      gridOptions: {
        localeText: {
          noRowsToShow:
            '<div id="no-rows-manning-vessel-list" class="aisea-text-16-400-black">表示する乗船期間がありません</div>',
        },
        context: {
          componentParent: this,
        },
      },
      pageSize: 25,
      sortType: null,
      sortColumnKey: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        icons: {
          sortAscending:
            '<span class="material-icons">keyboard_arrow_up</span>',
          sortDescending:
            '<span class="material-icons">keyboard_arrow_down</span>',
          sortUnSort: '<span class="material-icons">unfold_more</span>',
        },
        unSortIcon: true,
        comparator: () => {
          return;
        },
      },
      columnDefs: [],
      components: {
        CellRendererVesselName,
        CellRendererRowActionButtons,
      },
      isReadyPagination: false,
      prevRoute: null,

      vesselOptions: [],
      dialogSelectedVessel: null,
      dialogStartDate: null,
      dialogEndDate: null,
      dialogTargetRowData: null,

      roleOptions: [],

      isAllPeriod: false,

      workPeriodOptions: [],
      selectedWorkPeriod: null,
    };
  },
  watch: {
    currentPage() {
      this.fetchManningVesselPeriod();
    },
    activeSidebarCrew(val) {
      if (!val) {
        document.getElementById("manning-vessel-list").click();
      }
    },
    activeTab(val) {
      if (val === 2) {
        this.autoSizeAll();
      }
    },
    dialogStartDate() {
      // 必須の役職の日付は乗船期間の開始日で固定する
      const newValue = this.mandatoryRoleFormItems[0]
        ? this.mandatoryRoleFormItems[0]
        : {};
      newValue.date = this.dialogStartDate;
      this.mandatoryRoleFormItems[0] = newValue;
    },

    isAllPeriod() {
      this.fetchManningVesselPeriod();
    },
    selectedWorkPeriod() {
      this.fetchManningVesselPeriod();
    },
  },
  computed: {
    filteredVesselOptions() {
      if (this.actionMode == "transfer") {
        return this.vesselOptions.filter(vessel => {
          return vessel.value != this.dialogTargetRowData.vessel_id;
        });
      } else {
        return this.vesselOptions;
      }
    },
    getDialogValidationMessage() {
      if (
        !this.dialogStartDate ||
        !this.dialogEndDate ||
        !this.dialogSelectedVessel
      ) {
        return "入力されていない項目があります";
      }
      const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
        this.optionalRoleFormItems
      );
      for (let i = 0; i < combinedRoleFormItems.length; i++) {
        if (
          !combinedRoleFormItems[i] ||
          !combinedRoleFormItems[i].date ||
          !combinedRoleFormItems[i].role
        ) {
          return "入力されていない項目があります";
        }
      }
      for (let i = 0; i < combinedRoleFormItems.length - 1; i++) {
        if (
          !moment(combinedRoleFormItems[i + 1].date).isAfter(
            moment(combinedRoleFormItems[i].date)
          )
        ) {
          return "役職の日付は前の役職の日付よりも後になるようにしてください";
        }
      }
      if (
        moment(
          combinedRoleFormItems[combinedRoleFormItems.length - 1].date
        ).isAfter(moment(this.dialogEndDate))
      ) {
        return "役職の日付は乗船期間の終了日よりも前になるようにしてください";
      }
      return null;
    },
    paginationPageSize() {
      return this.pageSize;
    },

    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },

    totalVessel() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },
    sortColumnList() {
      return this.columnDefs.map(x => x.field.toUpperCase());
    },
    roleList() {
      return this.crewRoles
        .map(role => {
          role.dispName = role["localized_key"] === "other" && role.name
            ? role.name
            : this.$t("Views.Crew." + role["localized_key"]);
          return role;
        })
        .filter(x => x.dispName);
    },
    dialogTargetPeriodLabel() {
      if (this.dialogTargetRowData != null) {
        return (
          this.dialogTargetRowData.daytime_in +
          "〜" +
          this.dialogTargetRowData.daytime_out
        );
      } else {
        return "";
      }
    },
  },
  methods: {
    getApproverFixed(roleId) {
      if (roleId === null || typeof roleId === "undefined") {
        return true;
      }
      const laborAdminType = this.roleOptions.find(el => el.value === roleId)
        .laborAdminType;
      return laborAdminType !== "VAR";
    },
    setActionDialogEdit(rowData) {
      this.dialogTargetRowData = rowData;

      const workPriodFrom = moment(
        this.dialogTargetRowData.daytime_in
      ).toDate();
      const workPriodTo = moment(this.dialogTargetRowData.daytime_out).toDate();
      this.dialogStartDate = workPriodFrom;
      this.dialogEndDate = workPriodTo;
      this.dialogSelectedVessel = this.dialogTargetRowData.vessel_id;
      const formRoleItem = this.dialogTargetRowData.roles.map(role => {
        return {
          role: role.id,
          date: moment(role.start_on).toDate(),
          is_labor_admin: role.labor_admin,
        };
      });
      const firstPart = formRoleItem.slice(0, 1);
      const secondPart = formRoleItem.slice(1);
      this.mandatoryRoleFormItems = firstPart;
      this.optionalRoleFormItems = secondPart;
      this.actionMode = "edit";
      this.actionDialogTitle = "乗船期間編集";
      this.actionDialogVesselFormLabel = "船名";
    },
    setActionDialogAdd() {
      this.clearDialogForm();
      this.actionMode = "add";
      this.actionDialogTitle = "乗船期間新規登録";
      this.actionDialogVesselFormLabel = "船名";
    },
    setActionDialogTransfer(rowData) {
      this.dialogTargetRowData = rowData;
      const workPriodFrom = moment().toDate();
      const workPriodTo = moment(this.dialogTargetRowData.daytime_out).toDate();
      this.dialogStartDate = workPriodFrom;
      this.dialogEndDate = workPriodTo;
      this.dialogSelectedVessel = null;
      const latestRole = this.dialogTargetRowData.roles[
        this.dialogTargetRowData.roles.length - 1
      ];

      this.mandatoryRoleFormItems = [
        {
          role: latestRole.id,
          date: moment().toDate(),
          is_labor_admin: latestRole.labor_admin
            ? latestRole.labor_admin
            : false,
        },
      ];
      this.optionalRoleFormItems = [];
      this.actionMode = "transfer";
      this.actionDialogTitle = "転船登録設定";
      this.actionDialogVesselFormLabel = "転船先船舶";
    },
    setDeleteDialog(rowData) {
      this.dialogTargetRowData = rowData;
    },
    deleteOptionalRoleFormItem(index) {
      this.optionalRoleFormItems.splice(index, 1);
    },
    setDialogSelectedPeriod(dateList) {
      this.dialogSelectedPeriod = dateList.map(element =>
        moment(element).format("YYYY-MM-DD")
      );
    },
    clearDialogForm() {
      this.dialogStartDate = null;
      this.dialogEndDate = null;
      this.dialogSelectedVessel = null;
      this.mandatoryRoleFormItems = [null];
      this.optionalRoleFormItems = [];
    },
    onActionDialogCancel() {
      this.showActionDialog = false;
    },
    async onAdd() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
          this.optionalRoleFormItems
        );
        const roleList = combinedRoleFormItems.map(element => {
          return {
            enterprise_crew_role_id: element.role,
            is_labor_admin: element.is_labor_admin
              ? element.is_labor_admin
              : false,
            start_on: moment(element.date).format("YYYY-MM-DD"),
          };
        });

        const payload = {
          boarding_status: 0,
          daytime_in: moment(this.dialogStartDate).format("YYYY-MM-DD"),
          daytime_out: moment(this.dialogEndDate).format("YYYY-MM-DD"),
          enterprise_manning_vessel_crew_roles: roleList,
          enterprise_manning_vessel_id: this.dialogSelectedVessel,
          version: 0,
        };
        const res = await enterpriseCrewManningVesselApi.add(
          this.enterpriseCrewId,
          payload
        );
        if (res.status == true) {
          this.updatedManningVesselPeriodIds.push(res.data.id);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間を追加しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "乗船期間の追加に失敗しました",
            text: res.code === 400 && res.message ? res.message : undefined,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
            fixed: true,
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchManningVesselPeriod();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    async onEdit() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
          this.optionalRoleFormItems
        );
        const roleList = combinedRoleFormItems.map(element => {
          return {
            enterprise_crew_role_id: element.role,
            is_labor_admin: element.is_labor_admin
              ? element.is_labor_admin
              : false,
            start_on: moment(element.date).format("YYYY-MM-DD"),
          };
        });

        const payload = {
          boarding_status: 0,
          daytime_in: moment(this.dialogStartDate).format("YYYY-MM-DD"),
          daytime_out: moment(this.dialogEndDate).format("YYYY-MM-DD"),
          enterprise_manning_vessel_crew_roles: roleList,
          enterprise_manning_vessel_id: this.dialogSelectedVessel,
          version: this.dialogTargetRowData.version,
        };
        const enterpriseManningVesselCrewId = this.dialogTargetRowData
          .manning_vessel_crew_id;
        const res = await enterpriseCrewManningVesselApi.update(
          this.enterpriseCrewId,
          enterpriseManningVesselCrewId,
          payload
        );
        if (res.status == true) {
          this.updatedManningVesselPeriodIds.push(res.data.id);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間を更新しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "乗船期間の更新に失敗しました",
            text: res.code === 400 && res.message ? res.message : undefined,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
            fixed: true,
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchManningVesselPeriod();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    onDeleteCancel() {
      this.showDeleteDialog = false;
    },
    async onTransfer() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
          this.optionalRoleFormItems
        );
        const roleList = combinedRoleFormItems.map(element => {
          return {
            enterprise_crew_role_id: element.role,
            is_labor_admin: element.is_labor_admin
              ? element.is_labor_admin
              : false,
            start_on: moment(element.date).format("YYYY-MM-DD"),
          };
        });

        const payload = {
          boarding_status: 0,
          daytime_in: moment(this.dialogStartDate).format("YYYY-MM-DD"),
          daytime_out: moment(this.dialogEndDate).format("YYYY-MM-DD"),
          enterprise_manning_vessel_crew_roles: roleList,
          enterprise_manning_vessel_id: this.dialogSelectedVessel,
          version: this.dialogTargetRowData.version,
        };
        const enterpriseManningVesselCrewId = this.dialogTargetRowData
          .manning_vessel_crew_id;
        const res = await enterpriseCrewManningVesselApi.transfer(
          this.enterpriseCrewId,
          enterpriseManningVesselCrewId,
          payload
        );
        if (res.status == true) {
          this.updatedManningVesselPeriodIds.push(res.data.id);
          this.updatedManningVesselPeriodIds.push(
            enterpriseManningVesselCrewId
          );
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間で転船しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "転船に失敗しました。",
            text: res.code === 400 && res.message ? res.message : undefined,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
            fixed: true,
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchManningVesselPeriod();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    async onDelete() {
      this.showDeleteDialog = false;
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const payload = {
          enterprise_manning_vessel_id: this.dialogTargetRowData
            .manning_vessel_id,
        };
        const enterpriseManningVesselCrewId = this.dialogTargetRowData
          .manning_vessel_crew_id;
        const res = await enterpriseCrewManningVesselApi.delete(
          this.enterpriseCrewId,
          enterpriseManningVesselCrewId,
          payload
        );

        if (res.status == true) {
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間を削除しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "乗船期間の削除に失敗しました。",
            text: res.code === 400 && res.message ? res.message : undefined,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
            fixed: true,
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchManningVesselPeriod();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    addRoleForm() {
      this.optionalRoleFormItems.push(null);
    },

    async onGridReady() {
      this.fetchManningVesselPeriod();
      this.autoSizeAll();
    },

    setPageSize(size) {
      this.pageSize = size;
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },

    onSort(object) {
      let sortColumn = object.columnApi.columnModel.viewportColumns.find(
        element => {
          return element.sort != null;
        }
      );
      this.sortType = sortColumn ? sortColumn.sort.toUpperCase() : null;
      this.sortColumnKey = sortColumn ? sortColumn.colId.toUpperCase() : null;
      this.currentPage = 1;

      this.fetchManningVesselPeriod();
    },

    updatedId(id) {
      if (id && !this.updatedIdList.includes(id)) {
        this.updatedIdList.push(id);
      }
    },

    onGridSizeChanged() {
      this.autoSizeAll();
    },

    onChangePageSize(size) {
      this.setPageSize(size);
      this.currentPage = 1;
      this.$nextTick(() => {
        this.fetchManningVesselPeriod();
      });
    },

    clearSearchQueryString() {
      this.searchQueryString = "";
    },

    autoSizeAll() {
      let allColumnIds = [];
      if (this.gridColumnApi && this.gridColumnApi.getAllColumns()) {
        this.gridColumnApi.getAllColumns().forEach(function(column) {
          allColumnIds.push(column.getId());
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
      }
      if (
        this.$refs.agGridTableManningVesselList &&
        this.$refs.agGridTableManningVesselList.$el.getBoundingClientRect()
          .width > 0
      ) {
        this.gridApi.sizeColumnsToFit(); // TODO: 横スクロールありの場合は、別途調整
      }
    },

    async fetchSearchOptions() {
      const res = await enterpriseManningCrewApi.fetchSearchParameter();
      this.filterCrewOptions = res.data.crews.map(crew => {
        return {
          id: crew.id,
          label: crew.name,
        };
      });
      this.filterVesselOptions = res.data.vessels.map(vessel => {
        return {
          id: vessel.id,
          label: vessel.name,
        };
      });
      this.filterRoleOptions = res.data.roles.map(role => {
        return {
          id: role.id,
          label: role.name,
        };
      });

      this.vesselOptions = res.data.vessels.map(vessel => {
        return {
          text: vessel.name,
          value: vessel.id,
        };
      });
    },
    async fetchRole() {
      const res = await enterpriseCrewRoleApi.search();
      this.roleOptions = res.data.roles.map(element => {
        return {
          text: element.name,
          value: element.id,
          laborAdminType: element.labor_admin_type,
        };
      });
    },

    getfetchManningVesselPeriodSearchQuery() {
      let query = {};
      query.now = DateUtil.toYMD(Date.now(), null);
      if (this.selectedFilterCrew) {
        query.crew_ids = this.selectedFilterCrew.join(",");
      }
      if (this.selectedFilterVessel) {
        query.vessel_ids = this.selectedFilterVessel.join(",");
      }
      if (this.selectedFilterRole) {
        query.role_ids = this.selectedFilterRole.join(",");
      }
      if (this.selectedFilterStatus.length > 0) {
        query.ashore =
          this.selectedFilterStatus.length == 1 &&
          this.selectedFilterStatus.includes(2)
            ? true
            : false;
      }
      query.size = this.pageSize;
      query.page = this.getCurrentPage();
      if (this.sortType && this.sortColumnKey) {
        query.sort_order = this.sortType;
        query.sort_column = this.sortColumnKey;
      }
      return query;
    },

    setTodayLaborSelected() {
      const currentWorkPeriod = this.workPeriodOptions.find(item => {
        const today = moment().format("YYYY-MM-DD");
        return moment(today).isBetween(
          moment(item.work_period_from),
          moment(item.work_period_to)
        );
      });
      //当日の日付にかかる基準労働期間を選択状態にする
      //基準労働期間が設定されている状態かつ当日の日付がない場合は、最新の基準労働期間を選択状態にする。
      if (currentWorkPeriod) {
        this.selectedWorkPeriod = currentWorkPeriod.value;
        this.isAllPeriod = false;
      } else if (!currentWorkPeriod && this.workPeriodOptions.length > 0) {
        this.selectedWorkPeriod = this.workPeriodOptions[0].value;
        this.isAllPeriod = false;
      } else {
        this.isAllPeriod = true;
      }
    },

    async fetchLaborPeriodOption() {
      const res = await enterpriseCrewLaborApi.search(this.enterpriseCrewId);
      if (res.status) {
        this.workPeriodOptions = res.data.crew_labors.map(crewLabor => {
          return {
            text: crewLabor.work_period_from + "〜" + crewLabor.work_period_to,
            value: crewLabor.id,
            work_period_from: crewLabor.work_period_from,
            work_period_to: crewLabor.work_period_to,
          };
        });
      }
    },

    getFetchCrewSearchQuery() {
      let query = {};
      query.now = DateUtil.toYMD(Date.now(), null);
      if (this.isAllPeriod) {
        query.started_at = moment()
          .subtract(5, "years")
          .local()
          .format("YYYY-MM-DD");
        query.ended_at = moment()
          .add(5, "years")
          .local()
          .format("YYYY-MM-DD");
      } else {
        const selectedWorkPeriod = this.workPeriodOptions.find(item => {
          return item.value == this.selectedWorkPeriod;
        });
        query.started_at = selectedWorkPeriod.work_period_from;
        query.ended_at = selectedWorkPeriod.work_period_to;
      }

      query.size = this.pageSize;
      query.page = this.getCurrentPage();
      if (this.sortType && this.sortColumnKey) {
        query.sort_order = this.sortType;
        query.sort_column = this.sortColumnKey;
      }

      return query;
    },
    compareRoles(a, b) {
      /*
      下記の優先順位でソート
      1.現在の日付が start_on と end_on の間にある場合。
      2.現在の日付より後の start_on で、現在に最も近い日付。
      3.現在の日付より前の end_on で、現在に最も近い日付。
      */
      const now = new Date();
      const nowTime = now.getTime();

      const aStart = new Date(a.start_on).getTime();
      const aEnd = new Date(a.end_on).getTime();
      const bStart = new Date(b.start_on).getTime();
      const bEnd = new Date(b.end_on).getTime();

      // 現在時刻がstart_onとend_onの間にあるかチェック
      const aInRange = nowTime >= aStart && nowTime <= aEnd;
      const bInRange = nowTime >= bStart && nowTime <= bEnd;

      if (aInRange && !bInRange) return -1;
      if (!aInRange && bInRange) return 1;

      // 現在時刻に近いstart_onを見つける
      const aStartDiff = Math.abs(nowTime - aStart);
      const bStartDiff = Math.abs(nowTime - bStart);

      if (aStartDiff !== bStartDiff) return aStartDiff - bStartDiff;

      // 現在時刻に近いend_onを見つける
      const aEndDiff = Math.abs(nowTime - aEnd);
      const bEndDiff = Math.abs(nowTime - bEnd);

      return aEndDiff - bEndDiff;
    },
    async fetchManningVesselPeriod() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const query = this.getFetchCrewSearchQuery();
        const res = await enterpriseCrewManningVesselApi.search(
          this.enterpriseCrewId,
          query
        );
        if (res.status) {
          this.tableData = res.data.enterprise_manning_vessel_crews.map(
            crew => {
              let roles = [...crew.roles];
              roles.sort(this.compareRoles);
              return {
                id: crew.id,
                daytime_in: moment(crew.daytime_in).format("YYYY/MM/DD"),
                daytime_out: moment(crew.daytime_out).format("YYYY/MM/DD"),
                name: crew.vessel.name,
                vessel_id: crew.vessel.id,
                roles: crew.roles,
                roleName: roles[0].name,
                is_labor_admin: roles[0].labor_admin ? "あり" : "なし",
                manning_vessel_crew_id: crew.id,
                manning_vessel_id: crew.vessel.id,
                onboard: crew.onboard ? "乗船中" : "下船中",
                updated_at: moment(crew.updated_at).format("YYYY/MM/DD HH:mm"),
                version: crew.version,
                action_disabled_transfer: !crew.onboard,
              };
            }
          );

          Object.keys(res.data.pageable).forEach(key => {
            Vue.set(this.pageable, key, res.data.pageable[key]);
          });
        }
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    customizeCellStyle(params) {
      if (this.updatedManningVesselPeriodIds.includes(params.data.id)) {
        return { backgroundColor: "lightyellow" };
      } else {
        return null;
      }
    },
  },

  async beforeMount() {
    this.gridOptions["onFirstDataRendered"] = this.autoSizeAll;

    const initialColumnDefs = [
      {
        headerName: "乗船日時",
        field: "daytime_in",
        minWidth: 140,
        width: 140,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "下船日時",
        field: "daytime_out",
        minWidth: 140,
        width: 140,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "船舶名",
        field: "name",
        minWidth: 160,
        width: 160,
        suppressSizeToFit: true,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "役職名",
        field: "roleName",
        minWidth: 140,
        width: 140,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "承認権限",
        field: "is_labor_admin",
        minWidth: 120,
        width: 120,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "ステータス",
        field: "onboard",
        minWidth: 120,
        width: 120,
        sortable: false,
        cellStyle: params => this.customizeCellStyle(params),
      },
      {
        headerName: "最終更新日時",
        field: "updated_at",
        minWidth: 240,
        width: 240,
        cellStyle: params => this.customizeCellStyle(params),
      },

      {
        headerName: "操作",
        field: "action",
        minWidth: 120,
        maxWidth: 120,
        cellRendererFramework: "CellRendererRowActionButtons",
        pinned: "right",
        resizable: false,
        sortable: false,
        cellRendererParams: {
          edit: data => {
            this.setActionDialogEdit(data);
            this.showActionDialog = true;
          },
          delete: data => {
            this.setDeleteDialog(data);
            this.showDeleteDialog = true;
          },
          transfer: data => {
            this.setActionDialogTransfer(data);
            this.showActionDialog = true;
          },
        },
        cellStyle: params => this.customizeCellStyle(params),
      },
    ];

    this.columnDefs = initialColumnDefs;
    this.$nextTick(async () => {
      this.autoSizeAll();
    });
  },
  async created() {
    await this.fetchSearchOptions();
    await this.fetchRole();

    await this.fetchLaborPeriodOption();
    await this.setTodayLaborSelected();
    await this.fetchManningVesselPeriod();
    window.addEventListener("resize", this.autoSizeAll, false);
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.autoSizeAll, false);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.manning-vessel-list-add-dialog {
  .vs-dialog {
    max-width: 520px;
  }

  label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .validation-label {
    color: red;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .fixed-width-item {
    width: 368px;
  }
}

#manning-vessel-list {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-grid-table {
    height: 100%;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .ag-header-cell-text {
      font-family: $aisea-font-family;
      font-size: 12px;
      font-weight: 600;
    }

    .ag-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
    .ag-header-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .ag-header-cell {
    padding-right: 0;
  }
  .vs-tabs--content {
    padding: 4px 0 0 0;
  }

  .manning-vessel-incremental-search {
    border-radius: 6px;
    width: 2rem;
    transition: all 0.2s 0s ease;

    .vs-inputx {
      background-color: $aisea-pure-white;
      border: none !important;
      // padding-left: 2rem !important;
      padding: 10px 0 8px 2rem !important;
      font-family: $aisea-font-family;
      font-size: 16px !important;
      font-weight: 400;
      color: $aisea-dark-gray;
    }
    .vs-input--icon {
      border-right-color: #ffffff00;
      margin-top: 0.2rem;
      font-size: 16px;
    }
    .vs-input--input:focus {
      box-shadow: 0 3px 10px 0 rgba($aisea-blue, 0.15);
    }
    .vs-input--placeholder {
      color: $aisea-light-gray !important;
      padding-left: 1.8rem !important;
      padding-top: 0.8rem !important;
    }
  }
  .sort-icons {
    flex-direction: column;
    z-index: 9;
    i {
      cursor: pointer;
      border-radius: 4px;
      &:hover {
        background-color: $aisea-white;
      }
    }
  }
  .vs-pagination--ul {
    span {
      font-size: 12px;
      font-family: $aisea-font-family;
      font-weight: 400;
    }
  }
  #manning-vessel-list-hover-menu {
    height: 0;
    right: 31px;

    .manning-vessel-list-hover-icon {
      border-radius: 4px;
      padding: 8px;
      &:hover {
        background-color: $aisea-light-white;
      }
    }
  }

  .vue-treeselect__limit-tip-text {
    color: $aisea-blue !important;
  }

  .vue-treeselect--open .vue-treeselect__control {
    border-top-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__menu {
    box-shadow: 2px 5px 10px 0.5px #00000026;
    border-bottom-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__multi-value-item {
    color: $aisea-blue !important;
  }

  .vue-treeselect__control {
    width: 190px;
    height: 36px;
  }
}

.manning-vessel-list-add-dialog {
  .form-scroll-area {
    max-height: 30vh;
    overflow-y: auto;
    .dropdown-select {
      min-width: 160px;
      max-width: 160px;
    }
    .add-option-button {
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.manning-vessel-list-delete-confirm {
  .vs-dialog-header {
    color: $aisea-black !important;
  }
}
</style>
